
import { useContext, useEffect, useState } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleDown } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

import { BlogCard } from "../../components/cards/blog.card";
import { Header } from "../../components/header/header";
import { SliderCarousel } from "../../components/utilities/slider";
import { imageData, strategyData } from "../../_helpers/mock";
import { Square, SquareY, SquareZ, Zoomer } from "../../components/cards/framer-motion";
import "../../styles/home.css";
import { SharpPoly } from "../../components/containers/sharp-polygon";
import { RoundPoly } from "../../components/containers/round-poly";
import { TextCard } from "../../components/cards/text-card";
import { Footer } from "../../components/footer/footer";
import { BlogPostContext } from "../../services/blogs/blogpost.context";


export const HomePage = () => {

    const { blogposts } = useContext(BlogPostContext);

    const navigateTo = useNavigate();

    const [currentIndex, setCurrentIndex] = useState(0);
    const [unravel, setUnravel] = useState(false);
    const [latest, setLatest] = useState();
    const [images, setImages] = useState();
    const [capImg, setCapImg] = useState();


    useEffect(() => {
        setLatest(blogposts[0]);
        const imagesArr = blogposts[0]?.images?.split(",");
        const cleanedAr = imagesArr?.map((i) => {
            i = i.replace(/]|"|\\|\[/g, "");
            return i;
        });

        const latestImag = cleanedAr?.find((el) => cleanedAr?.indexOf(el) === 0);

        setCapImg(latestImag);
        setImages(cleanedAr);

    }, [blogposts])

    const sentence = 'WE ARE TOGETHER FOR DEVELOPMENT AND PROSPERITY!';
    let wordsArray = sentence.split(' ');

    useEffect(() => {
        const writeWords = setTimeout(() => {
            setCurrentIndex((indx) => indx + 1);
            if (currentIndex > wordsArray.length) {
                setCurrentIndex((indx) => wordsArray.length + 1);
            }
        }, 500);
        return () => clearTimeout(writeWords);
    }, [wordsArray, currentIndex])



    return (
        <div className="f-pg">
            <Header pageTitle={"Welcome to Mbecuda Global"} />
            <div className="home-bg">
                <div className="blur-bg">
                    <p className="bg-text">
                        MBEI CULTURAL AND DEVELOPMENT ASSOCIATION
                    </p>
                    <p className="bg-text">
                        MBECUDA
                    </p>
                    <div
                        className={classNames("flx-r-w", 'bg-text')}
                        style={{ justifyContent: "center" }}
                    >
                        {wordsArray.map((wrd, i) => (

                            <div
                                className={classNames(
                                    "wrd-slide",
                                    { "sli": currentIndex > i },
                                )}
                                key={i}
                            >
                                {wrd}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <RoundPoly
                text={"Vision of MBECUDA"}
                bgColor={"#153e97"}
            />
            <p className={classNames('vis-txt', 'hr-4')}>
                The level of mobilization observed during the enthronement of FON MOKOM NJEI III on January 12, 2022 and during his reception in Yaounde February 26, 2022, are clear indications that Mbei sons and daughters at home and abroad, young and old, rich and poor, men and women alike, love their village very dearly. They are also fully mobilized to stand as one man behind the new Fon in promoting reconciliation, tolerance, the rapid development of our people as well as the recognition and territorial integrity of our beloved village. It is our desire to work towards maintaining and even surpassing this level of mobilization and commitment.
            </p>
            <div className="flx-c">
                <div>
                    <SliderCarousel data={imageData} words={imageData} />
                </div>
            </div>

            <div className="pg-sp" />

            <div className={classNames("flx-c")}>
                <div className="rw-elem">
                    <SharpPoly text={"Vision Statement"} bgColor={"#157997"} />
                </div>
            </div>
            <p className="mis-quote">
                <span className="quote-mark">
                    ----
                </span>
                <span className="quote-txt">
                    All Mbei sons and daughters at home and abroad, young and old, rich and poor, men and women alike, love their village very dearly, and are fully mobilized to stand as one man behind the new Fon in promoting reconciliation, tolerance, justice, peace and the rapid development of our people as well as the recognition and territorial integrity of our beloved village.
                </span>
                <span className="quote-mark">-----</span>
            </p>
            <div className="pg-cap">Our Strategies</div>
            <div className={classNames("str-section", 'flx-r-w', 'flx-j-c')}>
                <Square>
                    <TextCard
                        caption={"Increased Mobilisation"}
                        text={"We will promote our culture in all its forms, everywhere and at all times, including through music, dances, culinary arts, dressing, language, etc."}
                    />
                </Square>
                <SquareY>
                    <TextCard
                        caption={"Cultural Promotion"}
                        text={"No matter the locations and conditions in which Mbei sons and daughters are living, they need to stand up and be counted as members of the Mbei family. Nobody will be left behind."}
                    />
                </SquareY>
                <SquareZ>
                    <TextCard
                        caption={"People-focused Development"}
                        text={"Ours will be an era of people-focused development recognizing the importance of construction projects, including halls, roads, bridges, church houses and so on."}
                    />
                </SquareZ>
            </div>
            <div className={classNames("flx-c")}>
                <div className="rw-elem">
                    <SharpPoly text={"Our Primary Goals"} bgColor={"#232323"} />
                </div>
                <button
                    className="unfurl"
                    onClick={() => setUnravel((u) => !u)}
                >
                    {unravel ? "See less" : "See more"}
                    <FontAwesomeIcon
                        icon={faChevronCircleDown}
                        className={classNames("drop-chev", { 'fold-chev': unravel })}
                    />
                </button>
            </div>
            <div className={classNames("goals-box", { 'unraveled': unravel })}>

                {strategyData.map((str, id) => {
                    return (
                        <Zoomer>
                            <div
                                className={classNames('str-unit', 'flx-a-r')}
                                key={id}
                            >
                                <img src={`/svgs/${str.icon}`} alt="" className="alt-icon" />
                                <div className="alt-text">{str.text}</div>
                            </div>
                        </Zoomer>
                    )
                })}
            </div>
            <div className="flex-c">
                <RoundPoly
                    text={"Latest Blog Post"}
                    bgColor={"#3878ef"}
                />
            </div>
            <div className="flx-c">
                {blogposts?.length > 0 ?
                    <BlogCard
                        blogdata={latest}
                        image={capImg}
                        onClick={() => navigateTo('/blogdetail', {
                            state: {
                                blogData: latest,
                                images: images
                            }
                        })}
                    />
                    :
                    <div className="pg-cap">
                        No bloposts available for now
                    </div>

                }
            </div>
            <Footer />
        </div >
    )
}
